export default class FulfillmentTransaction {
  constructor(public contactId: string, public orderId: string, public transactionId: string) {}
}
